import React from 'react';

// eslint-disable-next-line react/prop-types
const EventConnector = ({ children, configuration }) => {
  if (!configuration) {
    return <> {children}</>;
  }

  // this would be needed to support services that require a connector (e.g. MQTT)
  const EffectiveConnector = null;

  return EffectiveConnector ? <EffectiveConnector>{children}</EffectiveConnector> : <> {children}</>;
};

export default EventConnector;
